"use strict";

angular.module("internal.education").directive("internalEducationCourseNavigation", [
    function() {
        return {
            restrict: "E",
            templateUrl:
                paths.app +
                "education/components/education-course-navigation/education-course-navigation.html",
            replace: true,
            controller: ('InternalNavigation', ['$scope', '$stateParams', 'Permissions', function ($scope, $stateParams, Permissions) {

                $scope.getPermission = function (state, variable) {
                    Permissions.view(state).then(function (access) {
                        $scope[variable] = access;
                    });
                };

                //Check if course has been created (has an id) to show side bar tabs
                $scope.showCourseTabs = false
                if ($stateParams.id) {
                    $scope.showCourseTabs = $stateParams.id != 'create';
                }
            }])
        };
    }
]);
